    
<template>
<!-- <Layout> -->
   <!--  <PageHeader :title="title" :items="items" /> -->
    <!--         <Layout>
            <PageHeader :title="title" :items="items" />
            Este é o site da Infinity
        </Layout>
 -->
    <div>
<!--         
        <a href="/home">
            <h1 class="text-center">Em breve aqui será o site da Infinity</h1>
        </a>
        <b-row>
            <b-col>
                <div>
                    <b-img :src="`${imgUrl}/media/loja/loja2.jpg`" fluid alt="Imagem da loja"></b-img>
                </div>
            </b-col>
        </b-row>
        
 -->    
        <div class="container-fluid barraSuperior" id="top">
            <div class="container">
                <b-row>

                    <!-- REDES SOCIAIS -->
                    <b-col cols="12" lg="9" md="9" sm="8" class="social">
                        <ul>
                            <li>
                                <a href="http://facebook.com/infinitygroupparaguay" target="_blank">
                                    <b-icon icon="facebook" size="sm"  class="redSocial facebookBlanco"></b-icon>
                                </a>
                            </li>
                            <li>
                                <a href="http://youtube.com" target="_blank">
                                    <b-icon icon="youtube" size="sm" class="redSocial youtubeBlanco" ></b-icon>
                                </a>
                            </li>
                            <li>
                                <a href="http://instagram.com/infinitygroupparaguay" target="_blank">
                                    <b-icon icon="instagram" size="sm" class="redSocial instagramBlanco" ></b-icon>
                                </a>
                            </li>
                            <li>
                                <a href="http://google.com" target="_blank">
                                    <b-icon icon="google" size="sm" class="redSocial googleBlanco" ></b-icon>
                                </a>
                            </li>
                            <li>
                                <a href="http://twitter.com" target="_blank">
                                    <b-icon icon="twitter" size="sm" class="redSocial twitterBlanco" ></b-icon>
                                </a>
                            </li>
                        </ul>
                    </b-col>

                    <!-- REGISTRO DE USUÁRIOS -->
                    <b-col cols="12" lg="3" md="3" sm="4" class="registro">
                        <ul>
                            <li><a href="#">Entrar</a></li>
                            <li> | </li>
                            <li><a href="#">Criar uma Conta</a></li>
                        </ul>
                    </b-col>
                </b-row>
            </div>
        </div>

        <header class="container-fluid">

            <div class="container">
                <b-row id="cabecalho">
                    <!-- LOGOTIPO -->
                    <b-col cols="12" lg="3" md="3" sm="2" id="logotipo">
                        <a href="/home">
                            <b-img :src="`${imgUrl}/media/loja/logotipo.png`" fluid alt="Logotipo da loja"></b-img>
                        </a>
                    </b-col>

                    <!-- CATEGORIAS E BUSCADOR -->
                    <b-col cols="12" lg="6" md="6" sm="8">
                        <b-row>
                        <!-- BOTAO CATEGORIAS -->
                        <b-col cols="12" lg="4" md="4" sm="4" class="backColor" id="btnCategorias">
                            <p>
                                CATEGORIAS
                                <span class="pull-right">
                                    <b-icon icon="border-width" aria-hidden="true" size="sm" @click="ativarCategorias" ></b-icon>
                                </span>
                            </p>
                        </b-col>

                        <!-- BUSCADOR -->
                        <b-col cols="12" lg="8" md="8" sm="8">
                            <div class="input-group" id="buscador">
                                <input v-model="termo" type="search" 
                                    @keypress.enter="listarProdutosByName"
                                    name="buscar" class="form-control input-custom" placeholder="Buscar">
                                <span class="input-group-btn">
                                    <a href="#">
                                        <button class="btn btn-default backColor" @click="listarProdutosByName">
                                            <b-icon icon="search" size="sm" ></b-icon>
                                        </button>
                                    </a>
                                        <router-link to="/home">
                                            <button class="btn btn-default backColor">
                                            <b-icon icon="search" size="sm" ></b-icon>
                                        </button>
                                        </router-link>
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                    </b-col>

                    <!-- CARRINHO -->
                    <b-col cols="12" lg="3" md="3" sm="2">
                        <!-- <div id="carrito">
                        <a href="#">
                            <button>
                                <b-icon icon="cart" aria-hidden="true"></b-icon>
                            </button>
                        </a>
                        <p>SEU CARRINHO <span class="cantidadCesta"></span><br>USD $ <span class="sumaCesta"></span></p>
                        </div> -->
                    </b-col>

                    <!-- CATEGORIAS -->
                    <div class="card">
                    <b-col cols="12" class="backColor" id="categorias" v-if="mostrarCategorias">
                        
                        <b-row>
                        
                            <b-col cols="12" lg="2" md="3" sm="4"  v-for="categoria in categorias" :key="categoria.id">
                                <ul>

                                <h4 @click="listarProdutosByCategoria(categoria.id)"><a href="#" class="pixelCategorias">{{categoria.descricao}}</a></h4>
                                <hr>
                                    
                                    <li class="backColor" v-for="subcategoria in categoria.subcategoria" :key="subcategoria.id" @click="listarProdutosBySubCategoria(subcategoria.id)"><a href="#" class="pixelSubCategorias">{{subcategoria.descricao}}</a></li>
                                    
                                </ul>
                            </b-col>
                            
                        
                        </b-row>
                    </b-col>
                    </div>

                </b-row>
            </div>

        </header>

        <section id="banner-loja">

        </section>

<!--         <header id="header">

            <nav id="navigation" class="navbar navbar-expand-lg navbar-dark bg-dark">
                <div class="container">
                    <div class="navbar-header">
                        <a href="" class="navbar-brand">Infinity</a>
                    </div>

                    <div class="collapse navbar-collapse"  id="navbar">
                        <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
                            <li class="nav-item"><a class="nav-link" href="" v-for="categoria in categorias" :key="categoria.id">{{categoria.descricao}}</a>
                                
                            </li>
                            <li class="nav-item"><a class="nav-link" href="">Menu</a></li>
                            <li class="nav-item"><a class="nav-link" href="">Menu</a></li>
                            <li class="nav-item"><a class="nav-link" href="">Menu</a></li>
                            
                        </ul>
                    </div>
                </div>
            </nav>

            <div class="container">
                <div class="col-xs-12 welcome">
                    <h1>Seja bem vindo!</h1>
                </div>
            </div>
        </header>
 -->

        <!-- PRODUTOS -->
        <div class="row justify-content-center" v-if="produtos.length">

    
            <div class="col-lg-9">
                <div class="row mb-3">
                    <div class="col-xl-4 col-sm-6">
                        <div class="mt-2">
                        <h5>Vitrine de produtos</h5>
                        </div>
                    </div>
                    <div class="col-lg-8 col-sm-6">
                        <form class="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
                        <div class="search-box me-2">
                            <div class="position-relative">
                            <input
                                type="text"
                                class="form-control border-0"
                                placeholder="Buscar..."
                                @input="searchFilter($event)"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                            </div>
                        </div>
                        <ul class="nav nav-pills product-view-nav">
                            <li class="nav-item">
                            <a class="nav-link active" href="javascript: void(0);">
                                <i class="bx bx-grid-alt"></i>
                            </a>
                            </li>
                            <li class="nav-item">
                            <a class="nav-link" href="javascript: void(0);">
                                <i class="bx bx-list-ul"></i>
                            </a>
                            </li>
                        </ul>
                        </form>
                    </div>
                </div>




                <div class="row">
                    <div
                        v-for="produto in produtos"
                        :key="produto.id"
                        class="col-xl-4 col-sm-6"
                    >
                        <div class="card p-1 m-1 card-sil" id="card-produto">
                        <div class="card-body">
                            <div class="product-img position-relative">
                            <div v-if="produto.discount" class="avatar-sm product-ribbon">
                                <span class="avatar-title rounded-circle bg-primary"
                                >-{{ produto.discount }}%</span
                                >
                            </div>
                            <router-link
                                :to="`/ecommerce/product-detail/${produto.id}`"
                            >
                                <img
                                :src="showImageList(produto.thumbnail)"
                                alt
                                class="img-fluid mx-auto d-block"
                                />
                            </router-link>
                            </div>
                            <div class="mt-4 text-center">
                            <h5 class="mb-3 text-truncate">
                                <router-link
                                class="text-dark"
                                :to="`/ecommerce/product-detail/${produto.id}`"
                                >{{ produto.descricao }}</router-link
                                >
                            </h5>
                            <p class="text-muted">
                                <i class="bx bxs-star text-warning"></i>
                                <i class="bx bxs-star text-warning"></i>
                                <i class="bx bxs-star text-warning"></i>
                                <i class="bx bxs-star text-warning"></i>
                                <i class="bx bxs-star"></i>
                            </p>
                            <h5 class="my-0">
                                <span class="text-muted me-2">
                                <del>${{ produto.preco | dolar }}</del>
                                </span>
                                <b>${{ produto.preco | dolar }}</b>
                            </h5>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <!-- end row -->

                <!-- <div class="row">
                <div class="col-lg-12">
                    <b-pagination
                    v-if="produtos.length > 0"
                    class="justify-content-center"
                    pills
                    v-model="currentPage"
                    :total-rows="produtos.length"
                    :per-page="6"
                    aria-controls="my-table"
                    ></b-pagination>
                </div>
                </div> -->
            </div>








        </div><!-- row -->

    </div> <!-- div final -->
    <!-- </Layout> -->
</template>





<script>
import appConfig from "@/app.config";
//import Layout from '../../layouts/auth'
//import Layout from '../../layouts/main'
//import PageHeader from '@/components/page-header'
import {ApiInv} from '../siscmpfc/inv/ApiInv.js'

export default {
   page: {
   title: "Site Infinity",
   meta: [{ name: "description", content: appConfig.description }]
  },
  //components: { Layout, PageHeader },
  //components: { Layout },
  //components: {},
  data() {
      return {
          title: "Site",
            items: [
                {
                text: "Dashboard",
                href: "/home",
                },
                {
                text: "Site",
                active: true,
                },
            ],
          imgUrl:'',
          //url:null,
          categorias:[],
          mostrarCategorias:false,
          api: new ApiInv,
          subcategoria : {id: 0, descricao: ""},
          produtos:{},
          currentPage:0,
          termo:'',
      }
  },
  created(){
      this.iniciar()
      this.listarProdutos()
  },
  mounted() {
      this.imgUrl=process.env.VUE_APP_IMG_URL
      //this.url=process.env.VUE_APP_SERVER_URL
      //this.listarProdutos()
  },
  methods:{
      ativarCategorias(){
          this.mostrarCategorias = !this.mostrarCategorias
      },
      async iniciar(){
          this.categorias = []
          //this.loading = true
          let result = await this.api.getCategorias()
          this.categorias = result
          let sub = await this.api.getSubCategorias()
          
          let aux = []
          this.categorias.forEach(categoria => {
              
              aux = []
              sub.forEach(subcategoria => {
                  if(subcategoria.categoria.id == categoria.id){
                      aux.push(subcategoria)
                  }
              });
              categoria.subcategoria = aux
              
          });
          //this.loading = false
          console.log("CATEGORIAS: =>", this.categorias)
        
      },

      showImageList(imagem){
            let result = ''
            if(imagem){
                if(imagem.startsWith('/media')){
                    result = this.imgUrl + imagem
                } else {
                    result = imagem
                }
            } else {
                result = this.imgUrl + 'media/img/empty.png'
            }
            return result
        },

      async listarProdutos(){
          this.imgUrl = ''
          this.produtos = []
          let produtos = await this.api.getProdutos()
          console.log(produtos)
          this.produtos = produtos
      },

      async listarProdutosByCategoria(id){
          this.imgUrl=process.env.VUE_APP_IMG_URL
          this.produtos = []
          console.log('id da categoria a ser buscada', id)
          let produtos = await this.api.getProdutos()
          console.log(produtos)
          this.produtos = produtos
          this.mostrarCategorias = false
      },

      async listarProdutosBySubCategoria(id){
          this.imgUrl=process.env.VUE_APP_IMG_URL
          this.produtos = []
          console.log('id da sub-categoria a ser buscada', id)
          let produtos = await this.api.getProdutoBySubcategoria(id)
          console.log(produtos)
          this.produtos = produtos
          console.log(this.produtos)
          this.mostrarCategorias = false
      },

      async listarProdutosByName(){
          let termo = this.termo
          this.imgUrl=process.env.VUE_APP_IMG_URL
          this.produtos = []
          let produtos = await this.api.getProdutoByName(termo)
          console.log(produtos)
          this.produtos = produtos
          console.log(this.produtos)
          this.mostrarCategorias = false
      },

      searchFilter(e) {
        const searchStr = e.target.value;
        let produtos = this.produtos
        this.produtos = produtos.filter((product) => {
            return (
            product.descricao.toLowerCase().search(searchStr.toLowerCase()) !== -1
            );
        });
      },
      irHome(){
          this.$router.push('/home')
      }
  }
};
</script>




<style>
/* ===============================================================================
                                ESTILO GERAL
=================================================================================*/
*{
    padding: 0px;
    /* margin: 0px; */
    list-style: none;
    text-decoration: none;
}

ul, ol{
    padding: 0px;
}

a:visited, a:link, a:focus, a:hover, a:active{
    list-style: none;
    text-decoration: none;
}

.barraSuperior{
    background-color: black;
}

.barraSuperior a{
    color: white;
}

.backColor, .backColor a{
    /* background-color: #47bac1; */
    color: black;
}


/* REDES SOCIAIS */
.redSocial{
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
}

/* FACEBOOK */
.facebookBlanco{
    color: white;
}
.facebookNegro{
    color:black;
}
.facebookColor{
    color: white;
    background: #46639f;
}

/* YOUTUBE */
.youtubeBlanco{
    color: white;
}
.youtubeNegro{
    color:black;
}
.youtubeColor{
    color: white;
    background: #d6513e;
}

/* INSTAGRAM */
.instagramBlanco{
    color: white;
}
.instagramNegro{
    color:black;
}
.instagramColor{
    color: white;
    background: linear-gradient(45deg, #fca925, #ee1d5f, #6350a2);
}

/* TWITTER */
.twitterBlanco{
    color: white;
}
.twitterNegro{
    color:black;
}
.twitterColor{
    color: white;
    background: #0ab2e6;
}

/* GOOGLE */
.googleBlanco{
    color: white;
}
.googleNegro{
    color:black;
}
.googleColor{
    color: white;
    background: #d71617;
}




/* ===============================================================================
                                ESTILO CABEÇALHO
=================================================================================*/
#top{
    display: none;
}

#top ul{
    padding-top: 8px;
}

#top ul li{
    display: inline;
    line-height: 20px;
    margin: 0px, 5px;
    color: white;
}

.social ul li a { /* faltou i ... não pega pq usei b-icon */
    font-size: 18px;
    margin: 0 5px;
}

.registro ul{
    text-align: right;
    font-size: 12px;
}


/* HEADER */
header ul{
    margin-left: 20px;
}
header h4{
    margin-left: 20px;
    color: white;
    font-weight: bold;
    /* text-transform: uppercase; */
    font-size: 1.5em;
    padding: 5px;
}
header h4:hover{
    border: 1px solid black;
    background: transparent;
}
header #logotipo{
    padding: 20px 60px;
    padding-left: 0px;
    width: 180px;
} 

header #btnCategorias{
    margin:20px 0;
}

header #btnCategorias p{
    line-height: 60px;
    margin-bottom: 0px;
    color: #1B1D27;
    font-weight: bold;
    /* text-transform: uppercase; */
    font-size: 1.5em;
}

header #btnCategorias p span{
    cursor: pointer;
}

/* BUSCADOR */
header #buscador{
    margin:20px 0;    
}

header #buscador input{
   /*  padding:19px;
    border-radius: 0; */
    background: transparent;
    border: 2px solid grey;
    padding: 20px;
}
header #buscador input:hover{
    border: 2px solid black;
}
header #buscador button{
    /* padding: 9px;
    border: 1px solid silver;
    border-radius: 0; */
    background: transparent;
    border: 2px solid grey;
    padding: 20px;
}
header #buscador button:hover{
    border: 2px solid black;
}
 
/* CARRINHO */
 header #carrito{
    margin:20px 0;
}

header #carrito button{
    padding: 9px 15px;
    border: 1px solid silver;
    border-radius: 0;
}

header #carrito p{
    padding: 2px;
    padding-left: 60px;
    border: 1px solid #aaa;
    font-size: 12px;
    margin-left: 50px;
    margin-top: -40px;
}

/* CATEGORIAS */
 header #categorias{
    /* display: none; */
    margin-top: -10px;
    position: relative;
}

header #categorias h4{
    margin-top: 20px;
    margin-bottom: -10px;
}

header #categorias hr{
    border: 1px solid rgba(255, 255, 255, .3);
}

header #categorias li a{
    /* color: white; */
    font-weight: 100;
    /* text-transform: uppercase; */
    font-size: 1.5em;
}

header #categorias li a:hover{
    border: 1px solid black;
    background: transparent;
}





/* PRODUTOS *************************************/
header-old{
    display: none;
}

header{
    /* background: url("../../../assets/images/loja/loja2.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 800px;
    opacity: 0.5; */
    

}
#banner-loja{
    background: url("../../../assets/images/loja/loja2.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 400px;
    opacity: 0.5;
    

}
header #navigation{
    width: 100%;
    min-height:80px;
    background: #21232C;
    opacity: 0.3;
}
header #navigation .navbar-brand{
    font-size: 2em;
    font-weight: bold;
    color: white;
    padding: 1em 0;

}
header #navigation #navbar{
    text-align: right;
}
header #navigation #navbar .navbar-nav li{
    padding: 1em 0;
}
header #navigation #navbar .navbar-nav li a{
    color: white;
    font-weight: bold;
    /* text-transform: uppercase; */
    font-size: 1.5em;
}
header #navigation #navbar a:hover{
    border: 1px solid white;
    background: transparent;
}

/* #navbar li a{
    color: white;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 1em;

} */

header .welcome h1{
    color: white;
    font-weight: 100;
    font-size: 3em;
    padding: 2em 0 0 0;
    text-align: center;
}

section img{
   /*  width: 200px; */
}

.card-sil{
    /* min-height: 300px; */
}

#card-produto img{
    max-height: 180px;
} 



/* VARIAVEIS 
$black: #000000;
$white: #FFFFFF;
$black-1: #21232C;
$black-title: #1B1D27;
$white-title: #FFFFFF;
$green: #8EA96F;
*/

.font-lato{
    font-family: 'Lato', sans-serif;
}

/* ===============================================================================
                                PONTOS DE QUEBRA
=================================================================================*/
/* TELA GRANDE LG > 1366PX */
@media (min-width: 1200px){
    .col-md-0{
        display: none;
    }

    header #logotipo{
        padding: 20px 60px;
        padding-left: 0px;
        width: 180px;
    }

    header #carrito{
        padding-left: 100px;
    } 

    #card-produto{
        height: 400px;
        padding: 0px;
    }

    #card-produto img{
        max-height: 260px;
    }
}


/* TELA MEDIA TABLET HORIZONTAL MD 1024 */
@media (max-width:1199px) and (min-width:992px){
    .col-md-0{
        display: none;
    }

    #card-produto img{
        max-height: 180px;
    }
}


/* TELA PEQUENA TABLET VERTICAL SM 768PX */
@media (max-width:991px) and (min-width:768px){
.col-md-0{
        display: none;
    }
    /* header #carrito{
        padding-left: 55px;
    }
    header #carrito p{
        display: none;
    } */
}




/* CELULARES */
@media (max-width:767px) {
    #top ul{
        text-align: center;
    }
    #top #registro{
        border-top: 1px solid#222;
    }
    .col-md-0{
        display: none;
    }
    header #logotipo{
    padding-left: 30px;
    padding-bottom: 10px;
    width: 180px;
    }
    header #carrito{
        margin: 0px;
    }
    header #categorias{
        margin-bottom: 10px;
    }
    header #buscador{
        margin-bottom: 10px;
    }
}

</style>